import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

const StyledSale = styled.span(({ theme: { colors, fontSize } }) => ({
  display: 'inline-block',
  color: colors.white,
  backgroundColor: colors.turquoise,
  fontSize: fontSize * 0.625,
  padding: '4px 6px',
  borderRadius: fontSize,
  verticalAlign: 'bottom',
  fontWeight: 800,
}))

const ProductSale = ({ sale }) => (sale ? <StyledSale data-test="ProductSale">{sale}</StyledSale> : null)

ProductSale.propTypes = {
  sale: PropTypes.string,
}

ProductSale.defaultProps = {
  sale: '',
}

ProductSale.displayName = 'ProductSale'
ProductSale.whyDidYouRender = true

export default React.memo(ProductSale)
